import "@emotion/react";
import { main } from "./themes";
import { DataTableTheme } from "./data-table-theme";

export interface IGridColours {
    secondLevelRowHeaderLineColour: string;
    thirdLevelRowHeaderLineColour: string;
    alternateColumnColour: string;
    firstLevelRowHeaderBackgroundColour: string;
    secondLevelRowHeaderBackgroundColour: string;
    thirdLevelRowHeaderBackgroundColour: string;
}

export enum TypographyColorsEnum {
    CORE = "core",
    SUBDUED = "subdued",
    BLANK = "blank",
    PRIMARY = "primary",
}

export type IventisTheme = typeof main & Partial<DataTableTheme>;

declare module "@emotion/react" {
    // eslint-disable-next-line @typescript-eslint/no-empty-interface
    export interface Theme extends IventisTheme {}
}

export interface Text {
    color?: string;
}

export interface Nav {
    backgroundColor: string;
    color: string;
}
